/* Built In Imports */

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/* Styles */
/* Services */

/**
 * 
 * @param {Object} sectionContent 
 * @returns 
 */
const Quote = ({ sectionContent, lang, region }) => {
  let quote = sectionContent.quote;
  
  return (
    <Box w="100%" h="100%" mb="30px">
      <Box w="100%" bg="#fff4d7" p={{ base: '16px', md: '30px' }}>
        <Flex
          display="flex"
          justifyContent="center"
          alignItems={'center'}
          maxW="770px"
          mx="auto"
        >
          {/* Image Of the Quote */}
          <Image
            borderRadius={'100%'}
            width="80px"
            h="80px"
            alt="Sadhguru's Image"
            title="Sadhguru's Image"
            // src={`${config.staticPath}/sites/default/files/inline-images/2020-06-23%201.png`}
            src={`${config.imgPath}/d/46272/1670561810-2020-06-23-1.png`}
            className="Sadhguru's-Image"
          />
          <Flex
            width="calc(100% - 80px)"
            paddingLeft="20px"
            fontFamily="'FedraSansStd-book-i', sans-serif"
            fontSize="18px"
            color="#28231E"
            flexDir={'column'}
            marginTop="10px"
          >
            <Box
              as="span"
              fontFamily="'FedraSansStd-book-i', sans-serif"
              fontSize="18px"
              fontWeight={{ md: '400', base: '' }}
              color="#28231E"
              lineHeight={{ md: '150%', base: '' }}
            >
              {quote.match(/“[^”]*”/g)}
            </Box>
            <Box as="span" fontWeight={'bold'}>
              <Box
                as="span"
                color="#28231E"
                lineHeight={{ md: '150%', base: '' }}
              >
                {quote.match(/[^”]*$/g)}
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Quote;
